module.exports = __webpack_public_path__ + "img/slick_right_nano.631d6d28.svg";